module.exports = __webpack_public_path__ + "img/no-more-data.e53ea2b1.svg";